import * as React from "react";

const GVMenu: React.FC = () => {
    return (
        <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.2187 5.375H0.71875C0.34375 5.375 0 5.6875 0 6.09375C0 6.46875 0.3125 6.8125 0.71875 6.8125H18.2187C18.5937 6.8125 18.9375 6.5 18.9375 6.09375C18.9375 5.6875 18.5937 5.375 18.2187 5.375Z" fill="#1C1917"/>
            <path d="M18.2187 10.6875H0.71875C0.34375 10.6875 0 11 0 11.4062C0 11.8125 0.3125 12.125 0.71875 12.125H18.2187C18.5937 12.125 18.9375 11.8125 18.9375 11.4062C18.9375 11 18.5937 10.6875 18.2187 10.6875Z" fill="#1C1917"/>
            <path d="M0.71875 1.4375H18.2187C18.5937 1.4375 18.9375 1.125 18.9375 0.71875C18.9375 0.3125 18.625 0 18.2187 0H0.71875C0.34375 0 0 0.3125 0 0.71875C0 1.125 0.34375 1.4375 0.71875 1.4375Z" fill="#1C1917"/>
        </svg>
    );
};

export default React.memo(GVMenu);
